/*
 * vmcm-sample-pricing.js
 * Shared picker helpers. Never promise a browser-calculated box discount:
 * Shopify owns pricing; see docs/launch/automatic-sample-boxes.md for activation.
 */
(function (global) {
  'use strict';

  var BOX_SIZE = 6;

  function splitBundles(count) {
    return { bundles: Math.floor(count / BOX_SIZE), remainder: count % BOX_SIZE };
  }

  function money(n) {
    return '$' + n.toFixed(2);
  }

  function boxSaving(boxPrice, samplePrice) {
    return (BOX_SIZE * samplePrice) - boxPrice;
  }

  function nudgeLine(count) {
    if (count <= 0) return '';
    var split = splitBundles(count);
    if (split.remainder === 0) return 'Your samples are ready. Review them in your cart.';
    var need = BOX_SIZE - split.remainder;
    return (need === 1 ? 'One more' : need + ' more') + ' to complete the next group of six.';
  }

  function confirmLabel(count) {
    if (count <= 0) return 'Choose a finish to start';
    return 'Add ' + count + (count === 1 ? ' sample' : ' samples');
  }

  function buildCartItems(picks, boxVariantId) {
    // Keep each finish as an A4 line. Shopify's automatic Function owns price;
    // never swap lines into the legacy box product in the browser.
    return picks.map(function (pick) { return { id: pick.a4Id, quantity: 1 }; });
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = {
      BOX_SIZE: BOX_SIZE,
      splitBundles: splitBundles,
      money: money,
      boxSaving: boxSaving,
      nudgeLine: nudgeLine,
      confirmLabel: confirmLabel,
      buildCartItems: buildCartItems,
    };
    return;
  }

  global.VelvenSamplePricing = {
    BOX_SIZE: BOX_SIZE,
    splitBundles: splitBundles,
    money: money,
    boxSaving: boxSaving,
    nudgeLine: nudgeLine,
    confirmLabel: confirmLabel,
    buildCartItems: buildCartItems,
  };
})(typeof window !== 'undefined' ? window : this);
